import { createAction } from 'redux-actions';
import { createDeferredAction } from '../../utils/redux';
import { MODULE_NAME } from './constants';
import {
  BEGIN, CLEAR,
  CREATE,
  DELETE_BY_ID,
  FAILED,
  LOAD_BY_ID,
  LOAD_LIST,
  SUCCESSFUL,
  UPDATE,
} from '../../configs/actionNames';
import { USER_MODULE } from '../../configs/moduleNames';

export const createUser = createDeferredAction(MODULE_NAME + CREATE);
export const createUserSuccessful = createAction(MODULE_NAME + CREATE + SUCCESSFUL);
export const createUserFailed = createAction(MODULE_NAME + CREATE + FAILED);

export const editUserById = createDeferredAction(MODULE_NAME + UPDATE);
export const editUserByIdSuccessful = createAction(MODULE_NAME + UPDATE + SUCCESSFUL);
export const editUserByIdFailed = createAction(MODULE_NAME + UPDATE + FAILED);

export const loadUserById = createDeferredAction(USER_MODULE + LOAD_BY_ID);
export const loadUserByIdSuccessful = createAction(USER_MODULE + LOAD_BY_ID + SUCCESSFUL);
export const loadUserByIdFailed = createAction(USER_MODULE + LOAD_BY_ID + FAILED);
export const loadUserByIdClear = createDeferredAction(USER_MODULE + LOAD_BY_ID + CLEAR);

export const loadUserList = createDeferredAction(MODULE_NAME + LOAD_LIST);
export const loadListBegin = createAction(MODULE_NAME + LOAD_LIST + BEGIN);
export const loadListSuccessful = createAction(MODULE_NAME + LOAD_LIST + SUCCESSFUL);
export const loadListFailed = createAction(MODULE_NAME + LOAD_LIST + FAILED);

export const deleteUser = createDeferredAction(MODULE_NAME + DELETE_BY_ID);
export const deleteUserSuccessful = createAction(MODULE_NAME + DELETE_BY_ID + SUCCESSFUL);
export const deleteUserFailed = createAction(MODULE_NAME + DELETE_BY_ID + FAILED);
